module.exports = "/_next/static/images/e4fd8823aaad4906ab429c423606d3bc-bill-reopen-package.png";